import api from './api';

const base = '/admin/atividades';

export async function listAtividades({
  q = '',
  page = 1,
  limit = 25,
  codConv,
  codProcedi,
} = {}) {
  const params = { q, page, limit };
  if (codConv != null) params.codConv = codConv;
  if (codProcedi != null) params.codProcedi = codProcedi;
  const { data } = await api.get(base, { params });
  return data;
}

export async function createAtividade(payload) {
  const { data } = await api.post(base, payload);
  return data;
}

export async function updateAtividade(codProcedi, codConv, payload) {
  const { data } = await api.put(`${base}/${codProcedi}/${codConv}`, payload);
  return data;
}

export async function deleteAtividade(codProcedi, codConv) {
  const { data } = await api.delete(`${base}/${codProcedi}/${codConv}`);
  return data;
}
